/**
 * Datas fiscais vivem no fuso de Moçambique (Africa/Maputo, UTC+2, sem hora
 * de Verão). A BD corre em UTC; a conversão é sempre explícita, aqui. O
 * sistema Ribeiro teve um desvio de 2 horas por misturar as duas coisas.
 */
export const FISCAL_TZ = 'Africa/Maputo';
const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: FISCAL_TZ,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
});
function parts(d) {
    return Object.fromEntries(fmt.formatToParts(d).map((p) => [p.type, p.value]));
}
/** YYYY-MM-DD no fuso fiscal. */
export function fiscalDate(d = new Date()) {
    const p = parts(d);
    return `${p.year}-${p.month}-${p.day}`;
}
/** YYYY-MM-DDTHH:mm:ss no fuso fiscal (sem offset — formato SAF-T). */
export function fiscalDateTime(d = new Date()) {
    const p = parts(d);
    return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:${p.second}`;
}
export function fiscalYear(d = new Date()) {
    return Number(parts(d).year);
}
/** Soma dias a uma data YYYY-MM-DD (aritmética de calendário, sem fuso). */
export function addDays(date, days) {
    const [y, m, dd] = date.split('-').map(Number);
    const t = new Date(Date.UTC(y, m - 1, dd + days));
    return t.toISOString().slice(0, 10);
}
/** Primeiro e último dia de um período YYYY-MM. */
export function periodBounds(period) {
    if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(period))
        throw new Error(`Período inválido: ${period}`);
    const [y, m] = period.split('-').map(Number);
    const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
    return { from: `${period}-01`, to: `${period}-${String(last).padStart(2, '0')}` };
}
/**
 * Prazo da comunicação mensal (Aviso 40/AT/DGI/2025): último dia útil do mês
 * seguinte ao período. Não considera feriados nacionais — a lista vive na
 * aplicação (tabela `holidays`) e é passada aqui.
 */
export function atMonthlyDeadline(period, holidays = []) {
    const [y, m] = period.split('-').map(Number);
    const d = new Date(Date.UTC(y, m + 1, 0)); // último dia do mês seguinte
    for (;;) {
        const iso = d.toISOString().slice(0, 10);
        const dow = d.getUTCDay();
        if (dow !== 0 && dow !== 6 && !holidays.includes(iso))
            return iso;
        d.setUTCDate(d.getUTCDate() - 1);
    }
}
const MONTH_NAMES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
/** Soma meses mantendo o dia pretendido (31 → 28/29 em Fevereiro → 31 em Março). */
export function addMonthsAnchored(date, months, anchorDay) {
    const [y, m] = date.split('-').map(Number);
    const first = new Date(Date.UTC(y, m - 1 + months, 1));
    const last = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0)).getUTCDate();
    first.setUTCDate(Math.min(anchorDay, last));
    return first.toISOString().slice(0, 10);
}
/** {mes}, {ano} e {periodo} nas descrições: "Avença de {mes}" → "Avença de Outubro de 2026". */
export function fillPlaceholders(text, runDate, intervalMonths) {
    const [y, m] = runDate.split('-').map(Number);
    const end = new Date(Date.UTC(y, m - 1 + intervalMonths - 1, 1));
    const ey = end.getUTCFullYear(), em = end.getUTCMonth();
    const mes = `${MONTH_NAMES[m - 1]} de ${y}`;
    const periodo = intervalMonths === 1 ? mes : ey === y ? `${MONTH_NAMES[m - 1]} a ${MONTH_NAMES[em]} de ${y}` : `${MONTH_NAMES[m - 1]} de ${y} a ${MONTH_NAMES[em]} de ${ey}`;
    return text.replace(/\{mes\}/gi, mes).replace(/\{ano\}/gi, String(y)).replace(/\{periodo\}/gi, periodo);
}
//# sourceMappingURL=dates.js.map